<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="1100px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="px-4 pt-2 pb-1">
        <div style="
          padding: 8px 12px;
          background-color: #e3f2fd;
          border-left: 4px solid #2196f3;
          color: #0d47a1;
          font-size: 14px;
          border-radius: 2px;
        ">
          注：凡需要合同审批表的用印请在合同填报、协议报审两个功能申请！
        </div>
      </v-card-text>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-autocomplete
                    v-model="item.sealQuickId"
                    item-text="name"
                    item-value="dbid"
                    label="选择业务"
                    :items="sealQuickItems"
                    hide-details
                    clearable
                    :menu-props="{ maxHeight: 450 }"
                    :rules="rules.required"
                />
              </v-flex>

              <!--暂时只获取科学技术院作为科技合作协议的管理部门-->
              <v-flex xs12 sm6>
                <v-select
                    label="主管部门"
                    required
                    :rules="rules.required"
                    v-model="item.adminDeptId"
                    hint = "主管部门系统默认为科学技术院"
                    item-text="name"
                    item-value="dbid"
                    :items="deptItems.filter(d => d.dbid === 'Db2NIJQbgCU')"
                />
              </v-flex>

            </v-layout>

            <!-- 第二行：描述（全宽，视觉更舒适） -->
            <v-layout row wrap>
              <v-flex xs12 sm12>
                <!-- 或用 xs12 让描述全宽（推荐） -->
                <v-flex xs12>
                  <div
                      class="body-2 mt-1"
                      :class="{ 'grey--text': !selectedDescription }"
                      style="min-height: 20px;"
                  >
                    <template v-if="selectedDescription">
                      <strong>业务描述：</strong>{{ selectedDescription }}
                    </template>
                    <template v-else>
                      请选择一个业务以查看描述
                    </template>
                  </div>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md3>
                    <div class="field-item">
                      <label class="field-label">是否需要学院审核</label>
                      <div class="field-value">
                        <v-chip small :color="sealItem.needDeptReview ? 'primary' : 'grey'" text-color="white">
                          {{ sealItem.needDeptReview ? '是' : '否' }}
                        </v-chip>
                      </div>
                    </div>
                  </v-flex>

              <v-flex xs12 sm6 md3>
                    <div class="field-item">
                      <label class="field-label">是否需要上传附件</label>
                      <div class="field-value">
                        <v-chip small :color="sealItem.needAttachments ? 'primary' : 'grey'" text-color="white">
                          {{ sealItem.needAttachments ? '是' : '否' }}
                        </v-chip>
                      </div>
                    </div>
              </v-flex>

             <v-flex xs12 sm6 md3>
                    <div class="field-item">
                      <label class="field-label">是否需要选择项目</label>
                      <div class="field-value">
                        <v-chip small :color="sealItem.needProjType ? 'primary' : 'grey'" text-color="white">
                          {{ sealItem.needProjType ? '是' : '否' }}
                        </v-chip>
                      </div>
                    </div>
              </v-flex>

              <!-- 附件 -->
              <v-flex
                  xs12
                  v-if="sealItem.attachments && sealItem.attachments.length > 0"
                  class="enhanced-field mt-4"
              >
                <div class="enhanced-text-field">
                  <label class="enhanced-label font-weight-medium text--secondary mb-2 d-block">
                    业务相关说明及模板
                  </label>
                  <div class="enhanced-attachment-list">
                    <a
                        v-for="a in sealItem.attachments"
                        :key="a.dbid"
                        :href="`/api/ctra/file/${a.dbid}`"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="enhanced-attachment-link d-block mb-3 text-decoration-none"
                    >
                      <v-card
                          flat
                          tile
                          class="d-flex align-start pa-3 rounded-lg elevation-0 hover-elevation"
                          style="transition: box-shadow 0.2s, background-color 0.2s;"
                      >
                        <v-icon small color="primary" class="mt-1 mr-3 flex-shrink-0">mdi-file-document-outline</v-icon>
                        <div class="flex-grow-1" style="min-width: 0;">
                          <div class="text-body-2 font-weight-regular text-left">
                            {{ a.fileName }}
                            <span class="file-size text--disabled ml-1 caption">({{ a.size | fileSize }})</span>
                          </div>
                        </div>
                        <v-icon x-small color="grey lighten-1" class="ml-2 flex-shrink-0">mdi-open-in-new</v-icon>
                      </v-card>
                    </a>
                  </div>
                </div>
              </v-flex>

              <v-flex xs12 sm12>
                <v-autocomplete
                    v-if="selectedSealQuickNeedProj"
                    v-model="item.projectId"
                    item-text="displayText"
                    item-value="dbid"
                    label="选择项目"
                    :items="filteredProjItems"
                    hide-details
                    clearable
                    :menu-props="{ maxHeight: 450 }"
                    :rules="projectRules"
                />
              </v-flex>


              <v-flex xs12>
                <v-textarea
                    label="用印简要说明"
                    v-model="item.purpose"
                ></v-textarea>
              </v-flex>

              <v-flex xs4>
                <v-text-field
                    label="校章用印数"
                    v-model="item.instSealNum"
                    :rules="rules.amount"
                    oninput="this.value = this.value.replace(/[^\d]/g, '').replace(/(\..*)/g, '$1')"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs4>
                <v-text-field
                    label="法人章用印数"
                    v-model="item.corpSealNum"
                    :rules="rules.amount"
                    oninput="this.value = this.value.replace(/[^\d]/g, '').replace(/(\..*)/g, '$1')"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs4>
                <v-text-field
                    label="营业执照扫描件份数"
                    v-model="item.techSealNum"
                    :rules="rules.amount"
                    oninput="this.value = this.value.replace(/[^\d]/g, '').replace(/(\..*)/g, '$1')"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="事业单位法人证书复印件数"
                    v-model="item.certiLegalNum"
                    :rules="rules.amount"
                    oninput="this.value = this.value.replace(/[^\d]/g, '').replace(/(\..*)/g, '$1')"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="授权委托人章用印数"
                    v-model="item.prinSealNum"
                    :rules="rules.amount"
                    oninput="this.value = this.value.replace(/[^\d]/g, '').replace(/(\..*)/g, '$1')"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="科技院章用印数"
                    v-model="item.deptSealNum"
                    :rules="rules.amount"
                    oninput="this.value = this.value.replace(/[^\d]/g, '').replace(/(\..*)/g, '$1')"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="授权委托人证书数"
                    v-model="item.certiAuthorNum"
                    :rules="rules.amount"
                    oninput="this.value = this.value.replace(/[^\d]/g, '').replace(/(\..*)/g, '$1')"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>


              <v-flex xs12>
                <x-uploader
                    label="附件列表"
                    v-if="selectedSealQuickNeedAttach"
                    :action="fileUri"
                    v-model="item.attachments"
                    :size="Number(20)"
                    :description="[
                  '单个附件大小不超过 20M.',
                  '推荐上传 PDF 格式文件.'
                ]"
                />
              </v-flex>

            </v-layout>


          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSubmit">保存
        </v-btn>
      </v-card-actions>

      <v-divider style="max-height: 1px"/>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
import {mapGetters} from "vuex";
import XUploader from '@/components/global/Uploader'

const baseUri = '/api/seal/quick';
const userProjUri = '/api/seal/quick/proj/getByUser';
const getSealQuick = '/api/seal/quick/get/Seal/Quick';
const deptURI = '/api/syst/department';
export default {
  mixins: [mixin.edit(baseUri)],
  components: {XUploader},
  data() {
    return {

      fileUri: '/api/ctra/file',

      sealQuickItems: [],
      projItems: [],
      description: '',

      formValid: false,

      // 检索、分页、排序条件条件
      query: {
        statusId: 'checked',
        leaderId: '',

        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        descending: null,
        totalItems: null
      },

      // 检索框
      form: {
        statusId: 'checked',
        leaderId: '',
      },

      item: {
        adminDeptId: 'Db2NIJQbgCU',
        sealQuickId: '',
        name:'',
        instSealNum: 0, //校章用印数
        corpSealNum: 0,  //法人章用印数
        techSealNum: 0,  //营业执照扫描件
        prinSealNum: 0,  //授权委托人章用印数
        deptSealNum: 0,  //科技院章用印数
        certiLegalNum: 0, //事业单位法人证书复印件数
        certiAuthorNum: 0, //授权委托人证书数
      },

      freshItem: {
        sealQuickId: null,
        projectId: '',
        adminDeptId: 'Db2NIJQbgCU',
        statusId: 'draft',
        phone: '',
        name: '',
        instSealNum: 0, //校章用印数
        corpSealNum: 0,  //法人章用印数
        techSealNum: 0,  //营业执照扫描件
        prinSealNum: 0,  //授权委托人章用印数
        deptSealNum: 0,  //科技院章用印数
        certiLegalNum: 0, //事业单位法人证书复印件数
        certiAuthorNum: 0, //授权委托人证书数
        note: "",
        purpose: "",
        sealPch: ''
      },

      sealItem: {},

      deptItems: [],

      rules: {
        amount: [
          v => v != null && v !== '' || '必填项。', // 允许 0
          v => {
            const num = Number(v);
            return !isNaN(num) && num >= 0 && Number.isInteger(num);
          }
         ],
        required: [
          v => !!v || '必填项。'
        ],
      }
    }
  },

  created() {
    // 加载审核状态
    const vm = this
    this.axios.all([
      this.axios.get(getSealQuick, {params: {limit: 65535, disabled: 'F'}}),
      this.axios.get(userProjUri, {params: {limit: 65535, disabled: 'F', userId:vm.userId}}),
      this.axios.get(deptURI, {params: {limit: 65535, disabled: 'F'}}),
    ]).then(
        this.axios.spread(
            (rspSeal,rspProj,rspDept) => {
              vm.sealQuickItems = rspSeal.data.items;
              vm.deptItems = rspDept.data.items;
              // 预处理 projItems，添加 displayText
              vm.projItems = rspProj.data.items.map(item => {
                // 安全取值
                const projectName     = item.name || '';
                const projectType    = (item.type && item.type.name) || '';
                const client         = item.client || '';
                const contractAmount = item.contractAmounts != null ? parseFloat(item.contractAmounts) : null;
                const entryDate      = item.entryDate ? this.formatDate(item.entryDate) : '';

                // 格式化合同金额（可选：千分位、保留两位小数）
                const formattedAmount = contractAmount !== null
                    ? `¥${contractAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : '';

                // 拼接非空部分
                const parts = [
                  projectName,
                  projectType,
                  client,
                  formattedAmount,
                  entryDate
                ].filter(part => part.trim() !== '');

                return {
                  ...item,
                  displayText: parts.join(' | ')
                };
              });

            }
        )
    )
  },

  computed: {
    selectedDescription() {
      if (!this.item.sealQuickId) return null;
      const item = this.sealQuickItems.find(i => i.dbid === this.item.sealQuickId);
      return item ? item.description : null;
    },

    filteredProjItems() {
      // 如果没有选择业务，则返回空或全部（按需）
      if (this.item.sealQuickId == null) {
        return []; // 或 return this.projItems;
      }

      // 根据 selectedSealQuickId 找到对应的 sealQuickItem
      const selectedSeal = this.sealQuickItems.find(
          item => item.dbid === this.item.sealQuickId
      );

      // 检查 projtype 是否存在且是数组
      if (!selectedSeal || !Array.isArray(selectedSeal.projtype)) {
        return [];
      }


      // 提取所有 projType 字符串（注意字段名是 projType，不是 dbid！）
      const allowedProjTypeIds = selectedSeal.projtype
          .map(pt => pt.projType) // 注意：是 pt.projType，不是 pt.dbid
          .filter(id => id != null); // 过滤掉 null/undefined

      window.console.log("allowedProjTypeIds", allowedProjTypeIds);

      if (allowedProjTypeIds.length === 0) {
        return [];
      }

      // 过滤 projItems：只要 type.dbid 在 allowedProjTypeIds 中就保留
      return this.projItems.filter(proj =>
          proj.type && allowedProjTypeIds.includes(proj.type.dbid)
      );
    },

    selectedSealQuickNeedProj() {
      const selected = this.sealQuickItems.find(
          item => item.dbid === this.item.sealQuickId
      );
      return selected ? selected.needProjType === true : false;
    },

    selectedSealQuickNeedAttach() {
      const selected = this.sealQuickItems.find(
          item => item.dbid === this.item.sealQuickId
      );
      return selected ? selected.needAttachments === true : false;
    },

    projectRules() {
      if (!this.sealItem.needProjType) {
        return []; // 不需要校验
      }
      return [
        v => !!v || '请选择项目' // 必填校验
      ];
    },

    ...mapGetters(['userId','deptId','deptName','username'])
  },

  methods: {
    formatDate(dateStr) {
      // 支持 ISO 字符串、时间戳等
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return '';
      return date.getFullYear() + '-' +
          String(date.getMonth() + 1).padStart(2, '0') + '-' +
          String(date.getDate()).padStart(2, '0');
    },

    onSubmit() {
      if(this.sealItem.needAttachments)
      {
        if(this.item.attachments)
        {
          this.onSave()
        }
        else
        {
          alert("本业务需要上传相关附件！")
        }
      }
      else
      {
        this.onSave()
      }
    }

  },

  mounted() {
    window.console.log("mounted")
    this.item.certiLegalNum = '0'
    this.item.certiAuthorNum = '0'
    this.item.corpSealNum = '0'
    this.item.instSealNum = '0'
    this.item.techSealNum = '0'
    this.item.prinSealNum = '0'
    this.item.deptSealNum = '0'
  },

  watch: {
    // 监听 sealQuickId 的变化
    'item.sealQuickId'(newId) {
      if (newId) {
        const selectedItem = this.sealQuickItems.find(item => item.dbid === newId);
        this.item.name = selectedItem ? selectedItem.name : '';

        //获取选定业务相关附件
        this.axios.all([
          this.axios.get(`/api/seal/manage/${selectedItem.dbid}`),
        ]).then(
            this.axios.spread(
                (rspSeal) => {
                  this.sealItem = rspSeal.data;
                }
            )
        )

      } else {
        this.item.name = ''; // 清空
      }
    },

  },


}
</script>

<style scoped>
.enhanced-attachment-link {
  color: inherit !important;
}
.enhanced-attachment-link:hover .hover-elevation {
  background-color: rgba(0, 0, 0, 0.04) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
}
/* 可选：文件名过长时省略 */
.text-body-2 {
  word-break: break-word;
  /* 或使用以下两行实现单行省略：
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  */
}
</style>